module.exports = __webpack_public_path__ + "static/media/inove-02.53474564.png";